import { clientValuationsApi } from "#app/api/clients/clientValuationsRtk";
import { clearPortfolioByClientSessionCache } from "#app/domain/funnel/actives/PortfolioByClientSessionCache";
import { clearClientValuations } from "#app/store/RTK/slices/clientValuationsSlice";

/** Logout: drop stale ATON valuations + portfolio session cache. */
export function clearAtonSessionCaches(dispatch: (action: unknown) => void): void {
    dispatch(clearClientValuations());
    dispatch(clientValuationsApi.util.resetApiState());
    clearPortfolioByClientSessionCache();
}
